import { UAParser } from "ua-parser-js";
import { WIDGETS_CLASS_NAMESPACE } from "./constants";
export const canUseDOM = !!(typeof window !== "undefined" &&
    window.document &&
    window.document.createElement);
export function getBestName({ firstName, lastName, }) {
    return [firstName, lastName].filter(Boolean).join(" ") || null;
}
export function getComparativeReadableDate(now, then, options) {
    const timeSince = now.getTime() - then.getTime();
    // Has it been less than a minute?
    if (timeSince < 60_000) {
        return "Just now";
    }
    // Has it been less than an hour?
    if (timeSince < 3_600_000) {
        const timePassed = Math.floor(timeSince / 60_000);
        return timePassed === 1 ? "1 minute ago" : `${timePassed} minutes ago`;
    }
    // Has it been less than a day?
    if (timeSince < 86_400_000) {
        const timePassed = Math.floor(timeSince / 3_600_000);
        return timePassed === 1 ? "1 hour ago" : `${timePassed} hours ago`;
    }
    // Has it been less than a week?
    if (timeSince < 604_800_000) {
        const timePassed = Math.floor(timeSince / 86_400_000);
        return timePassed === 1 ? "1 day ago" : `${timePassed} days ago`;
    }
    // Has it been less than a month?
    if (timeSince < 2_592_000_000) {
        const timePassed = Math.floor(timeSince / 604_800_000);
        return timePassed === 1 ? "1 week ago" : `${timePassed} weeks ago`;
    }
    // Any later?
    return then.toLocaleDateString("en-US", {
        timeZone: options?.timeZone,
        month: "long",
        day: "numeric",
        // omit year if it's the same as the current year
        year: now.getFullYear() !== then.getFullYear() ? "numeric" : undefined,
    });
}
export function isObjectLike(value) {
    return typeof value === "object" && value !== null;
}
export function isErrorLike(value) {
    return isObjectLike(value) && typeof value.message === "string";
}
export async function parseErrorResponse(response) {
    try {
        const json = await response.json();
        if (!isObjectLike(json) || typeof json.message !== "string") {
            return {
                status: response.status,
                message: response.statusText,
            };
        }
        return {
            ...json,
            status: response.status,
            message: json.message || response.statusText,
        };
    }
    catch {
        return {
            status: response.status,
            message: response.statusText,
        };
    }
}
export function namespaceClassNames(...classNames) {
    return classNames
        .map((className) => `${WIDGETS_CLASS_NAMESPACE}-${className}`)
        .join(" ");
}
export function parseUserAgent(userAgent) {
    const { browser, device, os } = UAParser(userAgent ?? "");
    const browserName = browser.name?.replace(/^Mobile\s*/i, "");
    const pretty = [browserName, os.name].filter(Boolean).join(" on ");
    return { pretty, isMobile: device.type === "mobile" };
}
export function getUserLocation(location, ipAddress) {
    if (location) {
        return `${location.cityName}, ${location.countryISOCode}`;
    }
    if (ipAddress) {
        return ipAddress;
    }
    return "Unknown location";
}
//# sourceMappingURL=utils.js.map